import { useContext } from 'react';

import { FieldSelect } from '@/components/looker/field-select';
import { IWarrantyRepository } from '@/warranty/domain/repositories/warranty.repository';

import { WarrantyDetailsContext } from '../../pages/warranty-details';
import { ListEntities } from '../../queries/get-list-entities';

export type LevelFilterProps = {
  level: IWarrantyRepository.BatteryLevel;
  customerLabel: string;
  filters: IWarrantyRepository.Filters;
  onChange: (filters: Partial<IWarrantyRepository.Filters>) => void;
};

export function LevelFilter({
  level,
  customerLabel,
  filters,
  onChange,
}: LevelFilterProps) {
  const asset = useContext(WarrantyDetailsContext);

  const listEntities = ListEntities.useQuery({
    level,
    assetFullFrontendId: asset!.fullFrontendId,
    assetId: asset!.id,
    filters,
  });

  const filterKey = `${level}Id` as const;

  return (
    <FieldSelect
      label={customerLabel}
      placeholder={`Filter by ${customerLabel}`}
      value={filters[filterKey] as string | undefined}
      options={
        listEntities.data?.entities.map(
          (entity: IWarrantyRepository.Entity) => ({
            value: entity.fullFrontendId,
          }),
        ) ?? []
      }
      onChange={(value) => onChange({ [filterKey]: value })}
      isClearable={true}
      isLoading={listEntities.isFetching}
      disabled={listEntities.isFetching}
    />
  );
}
